import { render, staticRenderFns } from "./SaveMoneyHeader.vue?vue&type=template&id=770ef207&scoped=true&"
import script from "./SaveMoneyHeader.vue?vue&type=script&lang=js&"
export * from "./SaveMoneyHeader.vue?vue&type=script&lang=js&"
import style0 from "./SaveMoneyHeader.vue?vue&type=style&index=0&id=770ef207&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770ef207",
  null
  
)

export default component.exports